/* eslint-disable import/prefer-default-export */

export function getPermissionLabelString(permission, formatMessage, showRaw) {
  const { permissionName } = permission;
  
  /* kware start edit - Add translation support for permission sets */
  // Check if this is a permission set (mutable = true)
  const isPermissionSet = permission.mutable === true;
  
  let label;
  if (isPermissionSet) {
    // For permission sets, use the PermissionSets translation key
    label = formatMessage({
      id: `ui-users.PermissionSets.displayName.${permission.displayName || permission.permissionName}`,
      defaultMessage: permission.displayName || permission.permissionName,
    });
  } else {
    // For regular permissions, use the existing permissions translation key
    label = formatMessage({
      id: `ui-users.permissions.displayName.${permission.displayName || permission.permissionName}`,
      defaultMessage: permission.displayName || permission.permissionName,
    });
  }
  /* kware end edit */
  
  return showRaw ? `${permissionName} (${label})` : label;
}
